import { render, staticRenderFns } from "./ReviewCommentsWithPreview.vue?vue&type=template&id=75c96250&scoped=true"
import script from "./ReviewCommentsWithPreview.vue?vue&type=script&lang=js"
export * from "./ReviewCommentsWithPreview.vue?vue&type=script&lang=js"
import style0 from "./ReviewCommentsWithPreview.vue?vue&type=style&index=0&id=75c96250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c96250",
  null
  
)

export default component.exports